import { useState, useEffect } from "react";
import { FiSearch, FiX } from "react-icons/fi";

const SearchInput = ({
	onSearch,
	onClear,
	currentSearch = "",
	placeholder = "Search orders...",
}) => {
	const [searchTerm, setSearchTerm] = useState(currentSearch);

	// Update local state when currentSearch prop changes (from URL)
	useEffect(() => {
		setSearchTerm(currentSearch);
	}, [currentSearch]);

	const handleSubmit = (e) => {
		e.preventDefault();
		onSearch(searchTerm);
	};

	const handleClear = () => {
		setSearchTerm("");
		onClear();
	};

	return (
		<form onSubmit={handleSubmit} className="relative w-full" style={{ width: "400px" }}>
			<div className="relative">
				<input
					type="search"
					aria-label="Search orders"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					placeholder={placeholder}
					className="w-full h-11 pl-10 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:border-gray-500 text-sm"
				/>
				<FiSearch
					className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
					size={18}
				/>

				{searchTerm && (
					<button
						type="button"
						onClick={handleClear}
						aria-label="Clear order search"
						className="absolute right-20 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
					>
						<FiX size={18} />
					</button>
				)}

				<button
					type="submit"
					className="absolute right-0 top-0 h-11 px-4 bg-akgreen text-white rounded-r-lg hover:bg-akgreener focus:outline-none focus:ring-2 focus:ring-akgreen"
				>
					Search
				</button>
			</div>
		</form>
	);
};

export default SearchInput;
